import { Inline, Stack, useDevice, Viewport } from '@treatwell/ui';
import { CmsText } from 'js/components/CmsText/CmsText';
import React from 'react';

export type NearMeSummaryType = {
  icon: string;
  text: string;
};

export const Summary = ({ icon, text }: NearMeSummaryType) => {
  const { isMobile, isDesktop } = useDevice();

  return (
    <>
      <Viewport device="mobile" serverRender={isMobile}>
        <Stack space="md">
          <img alt="" src={icon} width={64} height={64} />
          <CmsText text={text} />
        </Stack>
      </Viewport>
      <Viewport device={['tablet', 'desktop']} serverRender={isDesktop}>
        <Inline space="xl" align="start">
          <img alt="" src={icon} width={100} height={100} />
          <CmsText text={text} />
        </Inline>
      </Viewport>
    </>
  );
};
